var _circle, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 1024 1024",
    height: "1024px",
    id: "Instagram",
    viewBox: "0 0 1024 1024",
    width: "1024px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0.9397 0.3421 -0.3421 0.9397 840.8064 -105.4335)",
    gradientUnits: "userSpaceOnUse",
    id: "bg_2_",
    x1: 231.4614,
    x2: -426.9566,
    y1: 1084.9277,
    y2: 300.3503
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1921,
    style: {
      stopColor: "#090909"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    style: {
      stopColor: "#212121"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    style: {
      stopColor: "#494948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#545453"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 512.001,
    cy: 512,
    fill: "url(#bg_2_)",
    id: "bg_1_",
    r: 512
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1 0 0 1 428.6797 183.0791)",
    gradientUnits: "userSpaceOnUse",
    id: "Shadow_1_",
    x1: -130.5234,
    x2: 445.5524,
    y1: 114.9102,
    y2: 690.9861
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    style: {
      stopColor: "#090909",
      stopOpacity: 0.5167
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#181818",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M564.542,1021.417L280,736.875L278.875,735l-9.772-381.901  c0,0,29.998-106.604,139.493-106.604s250.169,0,250.169,0s48.315,10.945,57.315,28.776h16.398l288.968,288.966  c0,0-5.925,46.839-12.128,69.719c0,0-12.438,46.392-22.561,69.75c0,0-13.656,32.226-22.135,47.624c0,0-7.117,13.825-14.727,26.011  c0,0-12.305,19.639-17.562,27.067c0,0-12.303,17.122-16.608,22.576c0,0-10.664,13.646-18.386,22.283c0,0-11.057,12.514-17.765,19.31  c0,0-6.57,6.95-14.039,13.94c0,0-23.227,21.294-33.406,29.231c0,0-38.493,28.975-56.518,39.278c0,0-26.516,15.543-43.139,23.099  c0,0-33.203,14.739-45.363,18.994c0,0-12.729,4.689-23.186,7.827c0,0-16.249,4.968-25.785,7.307c0,0-10.217,2.662-19.06,4.483  c0,0-11.486,2.598-22.819,4.37c0,0-17.959,2.747-23.312,3.362L564.542,1021.417z",
    fill: "url(#Shadow_1_)",
    id: "Shadow"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Instagram_1_"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 658.765,
    cy: 364.563,
    fill: "#FFFFFF",
    r: 33.136
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512.001,
    cy: 512,
    fill: "none",
    r: 121.412,
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    strokeWidth: 45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.358,612.506c0,91.127,73.875,165,165,165   h183.282c91.127,0,165-73.873,165-165V411.495c0-91.127-73.873-165-165-165H420.358c-91.127,0-165,73.873-165,165V612.506z",
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    strokeWidth: 45
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.298158404b01c8e48b97e011a78fb89d.svg";
export { ForwardRef as ReactComponent };